import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

// Redux type and action creators
const { Types, Creators } = createActions({
  pointDataRequested: ['lng', 'lat'],
  dataRequested: ['service'],
  dataFulfilled: ['json', 'id'],
  dataFailed: [],
  reset: []
})

export const DataTypes = Types
export default Creators

// Initial state
export const INITIAL_STATE = Immutable({
  fetching: false
})

// Redux reducers
export const pointDataRequested = (state, { lng, lat }) => {
  return state.merge({ fetching: true })
}

// Redux reducers
export const dataRequested = (state, { service }) => {
  return state.merge({ fetching: true })
}

export const dataFulfilled = (state, { json, id, event }) => {
  if (!event) {
    return state.merge({
      [id]: json,
      fetching: false
    })
  } else {
    return state    
  }
}

export const dataFailed = (state, { error }) => {
  console.log(error)
  return state.merge({ error })
}

export const dataReset = state => {
  return INITIAL_STATE
}

// Assign types to reducers
export const reducer = createReducer(INITIAL_STATE, {
  [Types.POINT_DATA_REQUESTED]: pointDataRequested,
  [Types.DATA_REQUESTED]: dataRequested,
  [Types.DATA_FULFILLED]: dataFulfilled,
  [Types.DATA_FAILED]: dataFailed,
  [Types.RESET]: dataReset
})



// WEBPACK FOOTER //
// ./src/redux/dataRedux.js